import { Box } from "@material-ui/core";
import { useContext } from "react";
import FormBase from "../../../../forms/FormBase";
import { RecadastramentoContext } from "../../../../context/RecadastramentoContext";
import ReRegistrationVocationalTraningComponent from "../../../components/tempo/Recadastramento/ReRegistrationVocationalTraningComponent";
import ReRegistrationAcademicDegreeComponent from "../../../components/tempo/Recadastramento/ReRegistrationAcademicDegreeComponent";
import { ReRegistrationVocationalTrainingFormItem } from "../../../../forms/recadastramento/ReRegistrationVocationalTrainingForm";
import { ReRegistrationCourseFormItem } from "../../../../forms/recadastramento/ReRegistrationCourseForm";
import { ReRegistrationMedicalLinkFormItem } from "../../../../forms/recadastramento/ReRegistrationMedicalLinkForm";
import { ReRegistrationAcademicDegreeFormItem } from "../../../../forms/recadastramento/ReRegistrationAcademicDegreeForm";
import ReRegistrationCourseComponent from "../../../components/tempo/Recadastramento/ReRegistrationCourseComponent";
import ReRegistrationMedicalLinkComponent from "../../../components/tempo/Recadastramento/ReRegistrationMedicalLinkComponent";
import TmpTitleFormCustom from "../../../../components/tempo/TmpTitleFormCustom/TmpTitleFormCustom";
import TmpShapeCustom from "../../../../components/tempo/TmpShapeCustom/TmpShapeCustom";

export default function AcademicDegreeVocationalTraningStep() {

    const { state, dispatch } = useContext(RecadastramentoContext);

    const onInputChange = (name: string, form: FormBase, value: any) => {
        dispatch({
            type: "UPDATE_FORM",
            payload: { form, value, name },
        });
    };

    const onCrudAcademicDegreeAction = (subTypeParam: "InsertOrUpdate" | 'Delete' | 'Cancel' | 'Edit', academicDegreeFormItem?: ReRegistrationAcademicDegreeFormItem) => {
        dispatch({
            type: "CRUD_FORM_REREGISTRATION_ACADEMIC_DEGREE",
            payload: { subType: subTypeParam, item: academicDegreeFormItem },
        });
    };

    const onCrudVocationalTraningAction = (subTypeParam: "InsertOrUpdate" | 'Delete' | 'Cancel' | 'Edit', reRegistrationVocationalTrainingFormItem?: ReRegistrationVocationalTrainingFormItem) => {
        dispatch({
            type: "CRUD_FORM_REREGISTRATION_VOCATION_TRANING",
            payload: { subType: subTypeParam, item: reRegistrationVocationalTrainingFormItem },
        });
    };

    const onCrudCourseAction = (subTypeParam: "InsertOrUpdate" | 'Delete' | 'Cancel' | 'Edit', reRegistrationCourseFormItem?: ReRegistrationCourseFormItem) => {
        dispatch({
            type: "CRUD_FORM_REREGISTRATION_COURSE",
            payload: { subType: subTypeParam, item: reRegistrationCourseFormItem },
        });
    };

    const onCrudMedicalLinkAction = (subTypeParam: "InsertOrUpdate" | 'Delete' | 'Cancel' | 'Edit', ReRegistrationMedicalLinkFormItem?: ReRegistrationMedicalLinkFormItem) => {
        dispatch({
            type: "CRUD_FORM_REREGISTRATION_MEDICAL_LINK",
            payload: { subType: subTypeParam, item: ReRegistrationMedicalLinkFormItem },
        });
    };

    return (
        <div>
            <TmpShapeCustom>

                <TmpTitleFormCustom marginTop={2} marginBottom={4}>
                    Formação Profissional
                </TmpTitleFormCustom>

                <Box mt={2} mb={4}>
                    <ReRegistrationVocationalTraningComponent
                        ReRegistrationVocationalTrainingForm={state.ReRegistrationVocationalTrainingForm}
                        onCancelItem={() => { onCrudVocationalTraningAction("Cancel") }}
                        onInserOrUpdateItem={() => { onCrudVocationalTraningAction("InsertOrUpdate") }}
                        onEditClick={(e: ReRegistrationVocationalTrainingFormItem) => { onCrudVocationalTraningAction("Edit", e) }}
                        onDeleteClick={(e: ReRegistrationVocationalTrainingFormItem) => { onCrudVocationalTraningAction("Delete", e) }}
                        onInputChange={onInputChange} />
                </Box>
            </TmpShapeCustom>
            <br />
            <TmpShapeCustom>

                <TmpTitleFormCustom marginTop={2}>
                    Títulos Acadêmicos
                </TmpTitleFormCustom>

                <Box mt={2} mb={4}>

                    <ReRegistrationAcademicDegreeComponent
                        ReRegistrationAcademicDegreeForm={state.ReRegistrationAcademicDegreeForm}
                        onCancelItem={() => { onCrudAcademicDegreeAction("Cancel") }}
                        onInserOrUpdateItem={() => { onCrudAcademicDegreeAction("InsertOrUpdate") }}
                        onEditClick={(e: ReRegistrationAcademicDegreeFormItem) => { onCrudAcademicDegreeAction("Edit", e) }}
                        onDeleteClick={(e: ReRegistrationAcademicDegreeFormItem) => { onCrudAcademicDegreeAction("Delete", e) }}
                        onInputChange={onInputChange} />
                </Box>
            </TmpShapeCustom>

            <br />
            <TmpShapeCustom>
                <TmpTitleFormCustom marginTop={2}>
                    Cursos
                </TmpTitleFormCustom>


                <Box mt={2} mb={4}>
                    <ReRegistrationCourseComponent
                        ReRegistrationCourseForm={state.ReRegistrationCourseForm}
                        onCancelItem={() => { onCrudCourseAction("Cancel") }}
                        onInserOrUpdateItem={() => { onCrudCourseAction("InsertOrUpdate") }}
                        onEditClick={(e: ReRegistrationCourseFormItem) => { onCrudCourseAction("Edit", e) }}
                        onDeleteClick={(e: ReRegistrationCourseFormItem) => { onCrudCourseAction("Delete", e) }}
                        onInputChange={onInputChange} />
                </Box>
            </TmpShapeCustom>

            <br />

            <TmpShapeCustom>

                <TmpTitleFormCustom marginTop={2}>
                    Vinculo Médico
                </TmpTitleFormCustom>

                <Box mt={2} mb={4}>
                    <ReRegistrationMedicalLinkComponent
                        ReRegistrationMedicalLinkForm={state.ReRegistrationMedicalLinkForm}
                        onCancelItem={() => { onCrudMedicalLinkAction("Cancel") }}
                        onInserOrUpdateItem={() => { onCrudMedicalLinkAction("InsertOrUpdate") }}
                        onEditClick={(e: ReRegistrationMedicalLinkFormItem) => { onCrudMedicalLinkAction("Edit", e) }}
                        onDeleteClick={(e: ReRegistrationMedicalLinkFormItem) => { onCrudMedicalLinkAction("Delete", e) }}
                        onInputChange={onInputChange} />
                </Box>
            </TmpShapeCustom>

        </div>
    )
}